// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */

/* .main-body {
  padding: 20px;
} */

/* .container {
  width: 100%;
  margin: 0 auto;
  padding: 0 20px; 
  box-sizing: border-box;
} */

/* Card Layout */

/* .listing-home {
  display: flex;
  flex-wrap: wrap;
  gap: 20px; 
  justify-content: space-between;
  margin-top: 40px;
  overflow: hidden;
} */

/* .card-im {
  flex: 1 1 calc(33.33% - 20px); 
  max-width: calc(33.33% - 20px); 
  box-sizing: border-box;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  background-color: white;
} */

/* .card-im:hover {
  transform: translateY(-5px);
} */

.img-fluid {
  width: 100%;
  height: auto;
  border-radius: 10px;
}

/* .details-gallery {
  background-color: #fcfdfe;
  .row {
    padding: 0;
    .col-md-6 {
      padding: 0;
      img {
        width: 760px;
        height: 606px;
      }
    }
    .col-md-3 {
      padding: 0;
    }
    img {
      width: 380px;
      height: 303px;
      object-fit: cover;
    }
  }
} */
.list_headline_two {
  font-size: 18px;
  font-weight: 600;
  margin-top: 10px;
}

.location_im {
  color: #666;
}

.details {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.price {
  font-size: 16px;
  font-weight: bold;
  color: black;
}

/* .theme-btn {
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  text-align: center;
  border-radius: 4px;
  display: inline-block;
  text-decoration: none;
  font-weight: bold;
}

.theme-btn:hover {
  background-color: #0056b3;
  text-decoration: none;
} */

/* .project-title {
  margin-top: 50px; 
  margin-bottom: 10px; 
  font-size: 2em; 
} */

/* .styled-link {
  text-decoration: none;
  color: #007bff;
} */

/* .styled-link:hover {
  color: #0056b3;
  text-decoration: underline;
} */

/* Adjusting spacing for the paragraph and the following heading */
p {
  margin: 5px 0; /* Reduce space around breadcrumb link */
  font-size: 1em;
  color: #666;
}

/* h2 {
  margin: 10px 0 20px;
  font-size: 1.5em;
  font-weight: 600;
} */

/* Responsive Design for Tablets and Mobile Devices */
@media (width <= 1024px) {
  /* Medium screens (Tablets) */
  .card-im {
    flex: 1 1 45%; /* Two cards per row */
    max-width: 100%;
  }
}

@media (width <= 768px) {
  /* Small screens (large phones) */
  .card-im {
    flex: 1 1 100%; /* Stack the cards */
    max-width: 100%;
  }

  .list_headline_two {
    font-size: 16px;
  }

  .price {
    font-size: 14px;
  }

  /* .theme-btn {
    font-size: 14px;
    padding: 8px 12px;
  } */
  .project-title {
    font-size: 1.75em;
  }
}

@media (width <= 480px) {
  /* Extra small screens (small phones) */
  .main-body {
    padding: 10px;
  }

  .container {
    padding: 0 10px;
  }

  .list_headline_two {
    font-size: 14px;
    margin-top: 5px;
  }

  .price {
    font-size: 12px;
  }

  /* .theme-btn {
    font-size: 12px;
    padding: 6px 10px;
  } */
  .project-title {
    font-size: 1.5em;
  }
}


.no-projects-message {
  text-align: center;
  font-weight: bold;
  font-size: 1.5rem;
  margin-top: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/styles/css/projectCard.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;;GAEG;;AAEH;;;;;GAKG;;AAEH,gBAAgB;;AAEhB;;;;;;;GAOG;;AAEH;;;;;;;;;;GAUG;;AAEH;;GAEG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;GAoBG;AACH;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH;;;;GAIG;;AAEH;;;GAGG;;AAEH;;;GAGG;;AAEH,kEAAkE;AAClE;EACE,aAAa,EAAE,wCAAwC;EACvD,cAAc;EACd,WAAW;AACb;;AAEA;;;;GAIG;;AAEH,qDAAqD;AACrD;EACE,6BAA6B;EAC7B;IACE,aAAa,EAAE,sBAAsB;IACrC,eAAe;EACjB;AACF;;AAEA;EACE,iCAAiC;EACjC;IACE,cAAc,EAAE,oBAAoB;IACpC,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;KAGG;EACH;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,uCAAuC;EACvC;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;KAGG;EACH;IACE,gBAAgB;EAClB;AACF;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["/* General Styles */\n\n/* .main-body {\n  padding: 20px;\n} */\n\n/* .container {\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px; \n  box-sizing: border-box;\n} */\n\n/* Card Layout */\n\n/* .listing-home {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px; \n  justify-content: space-between;\n  margin-top: 40px;\n  overflow: hidden;\n} */\n\n/* .card-im {\n  flex: 1 1 calc(33.33% - 20px); \n  max-width: calc(33.33% - 20px); \n  box-sizing: border-box;\n  border: 1px solid #e3e3e3;\n  border-radius: 8px;\n  padding: 15px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s;\n  background-color: white;\n} */\n\n/* .card-im:hover {\n  transform: translateY(-5px);\n} */\n\n.img-fluid {\n  width: 100%;\n  height: auto;\n  border-radius: 10px;\n}\n\n/* .details-gallery {\n  background-color: #fcfdfe;\n  .row {\n    padding: 0;\n    .col-md-6 {\n      padding: 0;\n      img {\n        width: 760px;\n        height: 606px;\n      }\n    }\n    .col-md-3 {\n      padding: 0;\n    }\n    img {\n      width: 380px;\n      height: 303px;\n      object-fit: cover;\n    }\n  }\n} */\n.list_headline_two {\n  font-size: 18px;\n  font-weight: 600;\n  margin-top: 10px;\n}\n\n.location_im {\n  color: #666;\n}\n\n.details {\n  display: flex;\n  justify-content: space-between;\n  margin: 10px 0;\n}\n\n.price {\n  font-size: 16px;\n  font-weight: bold;\n  color: black;\n}\n\n/* .theme-btn {\n  padding: 10px 15px;\n  background-color: #007bff;\n  color: white;\n  text-align: center;\n  border-radius: 4px;\n  display: inline-block;\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.theme-btn:hover {\n  background-color: #0056b3;\n  text-decoration: none;\n} */\n\n/* .project-title {\n  margin-top: 50px; \n  margin-bottom: 10px; \n  font-size: 2em; \n} */\n\n/* .styled-link {\n  text-decoration: none;\n  color: #007bff;\n} */\n\n/* .styled-link:hover {\n  color: #0056b3;\n  text-decoration: underline;\n} */\n\n/* Adjusting spacing for the paragraph and the following heading */\np {\n  margin: 5px 0; /* Reduce space around breadcrumb link */\n  font-size: 1em;\n  color: #666;\n}\n\n/* h2 {\n  margin: 10px 0 20px;\n  font-size: 1.5em;\n  font-weight: 600;\n} */\n\n/* Responsive Design for Tablets and Mobile Devices */\n@media (width <= 1024px) {\n  /* Medium screens (Tablets) */\n  .card-im {\n    flex: 1 1 45%; /* Two cards per row */\n    max-width: 100%;\n  }\n}\n\n@media (width <= 768px) {\n  /* Small screens (large phones) */\n  .card-im {\n    flex: 1 1 100%; /* Stack the cards */\n    max-width: 100%;\n  }\n\n  .list_headline_two {\n    font-size: 16px;\n  }\n\n  .price {\n    font-size: 14px;\n  }\n\n  /* .theme-btn {\n    font-size: 14px;\n    padding: 8px 12px;\n  } */\n  .project-title {\n    font-size: 1.75em;\n  }\n}\n\n@media (width <= 480px) {\n  /* Extra small screens (small phones) */\n  .main-body {\n    padding: 10px;\n  }\n\n  .container {\n    padding: 0 10px;\n  }\n\n  .list_headline_two {\n    font-size: 14px;\n    margin-top: 5px;\n  }\n\n  .price {\n    font-size: 12px;\n  }\n\n  /* .theme-btn {\n    font-size: 12px;\n    padding: 6px 10px;\n  } */\n  .project-title {\n    font-size: 1.5em;\n  }\n}\n\n\n.no-projects-message {\n  text-align: center;\n  font-weight: bold;\n  font-size: 1.5rem;\n  margin-top: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
